module.exports = "https://ec-cstatic.akulaku.net/mall/mobile/_next/static/images/bg_limited_offer-4cfc3d6832644ceb6a2f0a2a747ccdc5.jpg";